import { useAPIRoute } from '../../hooks';
import { useQuery } from 'react-query';
import { NeighborhoodServiceAreaInfo } from 'rwl-shared/dist/models/neighborhood';
type useServiceAreasListProps = {
    accountId: string;
};

export const useServiceAreasList = ({
    accountId,
}: useServiceAreasListProps) => {
    const url = useAPIRoute('/serviceareas/list', 'v1');

    return useQuery<NeighborhoodServiceAreaInfo[]>(
        ['serviceAreasList', accountId],
        async () => {
            try {
                const result = await fetch(
                    `${url}?` +
                        new URLSearchParams({
                            accountId: accountId,
                        }),
                    {
                        method: 'GET',
                    }
                );
                return result.json();
            } catch (e) {
                console.error('useServiceAreasList error:', e);
                throw e;
            }
        }
    );
};
